/*jshint esversion: 6 */

import RegionCountrySearch from '../forms/search/RegionCountrySearch';

import GenericSearch from '../forms/search/GenericSearch.js';
import CategorySearch from '../forms/search/CategorySearch.js';
import FilterSearch from '../forms/search/FilterSearch.js';

GenericSearch();
FilterSearch();
CategorySearch({
    locale: LOCALE,
    env: ENV,
});

RegionCountrySearch({
    locale: LOCALE,
    env: ENV
})